import React from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { Star, Heart, Home } from 'lucide-react';
import { Helmet } from 'react-helmet';

const ReviewThankYou = () => {
  const [searchParams] = useSearchParams();
  const rating = parseInt(searchParams.get('rating')) || 5;
  const already = searchParams.get('already') === 'true';

  // Generează steluțele
  const renderStars = () => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      stars.push(
        <Star
          key={i}
          className={`w-8 h-8 ${i <= rating ? 'text-yellow-400 fill-yellow-400' : 'text-gray-300'}`}
        />
      );
    }
    return stars;
  };

  return (
    <>
      {/* Exclude from Google indexing and Analytics */}
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
        <title>Mulțumim pentru review - CF-Extras.ro</title>
      </Helmet>

    <div className="min-h-screen bg-gradient-to-b from-emerald-50 to-white flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-xl p-8 text-center">
        {/* Logo */}
        <div className="mb-4">
          <img
            src="/logo-full.png"
            alt="CF-Extras.ro"
            className="h-32 mx-auto"
          />
        </div>

        {/* Icon */}
        <div className="mb-6">
          <div className="w-20 h-20 bg-emerald-100 rounded-full flex items-center justify-center mx-auto">
            <Heart className="w-10 h-10 text-emerald-600 fill-emerald-600" />
          </div>
        </div>

        {/* Title */}
        <h1 className="text-3xl font-bold text-gray-900 mb-4">
          {already ? 'Review-ul tău a fost deja înregistrat!' : 'Mulțumim pentru review!'}
        </h1>

        {/* Stars */}
        <div className="flex justify-center gap-1 mb-6">
          {renderStars()}
        </div>

        {/* Message based on rating */}
        <p className="text-gray-600 mb-8">
          {rating === 5 && 'Ne bucurăm că ai avut o experiență excelentă! Apreciem foarte mult feedback-ul tău.'}
          {rating === 4 && 'Mulțumim pentru apreciere! Ne străduim să oferim servicii de calitate.'}
          {rating === 3 && 'Mulțumim pentru feedback! Vom lucra să ne îmbunătățim serviciile.'}
          {rating <= 2 && 'Ne pare rău că experiența nu a fost pe măsura așteptărilor. Te rugăm să ne contactezi pentru a rezolva problema.'}
        </p>

        {/* Back to home button */}
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-6 py-3 bg-emerald-600 text-white rounded-lg hover:bg-emerald-700 transition-colors font-semibold"
        >
          <Home className="w-5 h-5" />
          Înapoi la pagina principală
        </Link>

        {/* Footer note */}
        <p className="mt-8 text-sm text-gray-400">
          Echipa cf-extras.ro
        </p>
      </div>
    </div>
    </>
  );
};

export default ReviewThankYou;
